import styled from "styled-components";
import backgroundImg from 'src/assets/images/background-login.jpg';

export const ContainerLogin = styled.div`
  background: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${backgroundImg});
  background-size: 100% 100%;
  flex:1;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const FormLoginContainer = styled.div`
  min-width: 30%;
  max-width: 90%;
  max-height: 90%;
  padding: 40px;
  border-radius: 30px;
  border-width: 2px;
  border-style: solid;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;